export default { logMessage: '13bbc81e3' };
